import { formatCurrency } from "../date-utils";
export const companyInvoiceRowsDtoFields = [{
        name: "codiceProdotto",
        title: "Codice prodotto",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.codiceProdotto
    }, {
        name: "descrizione",
        title: "Descrizione",
        render: (record) => record.descrizione
    }, {
        name: "importo",
        title: "Importo",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatCurrency(record.importo)
    }];
